import { GetSurveyForm } from '../adapters/GetSurveyForm';

export const functionArray = (
  patientID,
  idConfer,
  idType,
  formID,
  patientFormID
) => {
  return [
    {
      functions: GetSurveyForm,
      parameters: {
        ObjName1: 'FormView',
        ObjName2: 'GroupElements',
        ObjName3: 'GroupFormId',
        ObjName4: 'IdCartablePatient',

        user: {
          IdPatient: patientID,
          idConfer,
          idType,
          formID,
          patientFormID,
        },
      },
    },
  ];
};
